import { meetingCostService } from '../../services/MeetingCostService';

export function calculateMeetingCost({ attendees, durationMinutes, prepTimeMinutes }) {
  return meetingCostService.calculateCost({ attendees, durationMinutes, prepTimeMinutes });
}